import React from 'react';
const LoadingSpinner = () => {
   return (
      <div className="min-h-screen flex items-center justify-center bg-gradientBg">
         <div className="text-center">
            <div className="inline-block animate-spin rounded-full h-16 w-16 border-t-4 border-b-4 border-primary"></div>
            <div className="mt-8 h-16">
               <div className="animate-fade">
                  <p className="text-lg font-poppins text-primary">
                     Where Sustainability Meets Credibility
                  </p>
               </div>
            </div>
         </div>
      </div>
   );
};
export default LoadingSpinner;